import { DerogationButton } from './DerogationButton';

export function CreateQuoteDerogationButton({ overridenBranchId }: { overridenBranchId?: string }) {
  return <DerogationButton action="QUOTE" overridenBranchId={overridenBranchId} />;
}
